import axios from 'axios';

axios.defaults.baseURL = '/bbr/api';
axios.defaults.withCredentials = true;

export default {
    methods: {
        axiosPost(url, data) {
//            this.$store.dispatch('updateTimerRestart', true);

            axios.interceptors.response.use(
                response => {
                return response;
            },
            error => {
                const { response } = error;
                if (response && response.status === 403) {
                    window.location = '/cp';
                }

                return Promise.reject(error);
             });

            return axios.post(url, data);
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/axios-post.js